import page from "../components/TmsPageConfig/fields";
import title from "../components/TmsTitle/fields";
import text from "../components/TmsText/fields";
import button from "../components/TmsButton/fields";
import image_list from "../components/TmsImageList/fields";
import image_set from "../components/TmsImageSet/fields";
import video from "../components/TmsVideo/fields";
import audio from "../components/TmsAudio/fields";
import middle_nav from "../components/TmsMiddleNav/fields";
import top_nav from "../components/TmsTopNav/fields";
import bottom_nav from "../components/TmsBottomNav";
import notice_board from "../components/TmsNoticeBoard/fields";
import shop_header from "../components/TmsShopHeader/fields";
import personal_info from "../components/TmsPersonalInfo/fields";
import customer_service from "../components/TmsCustomerService/fields";
import custom_menu from "../components/TmsCustomMenu/fields";
import split_line from "../components/TmsSplitLine/fields";
import back_top from "../components/TmsBackTop/fields";
import rule from "../components/TmsRule/fields";
import countdown from "../components/TmsCountdown/fields";
import copy_text from "../components/TmsCopyText/fields";
import contact_info from "../components/TmsContactInfo/fields";
import anchor from "../components/TmsAnchor/fields";
import jump_app from "../components/TmsJumpApp/fields";
import bottom_float from "../components/TmsBottomFloat/fields";
import fix_icon from "../components/TmsFixIcon/fields";
import swiper_nav from "../components/TmsSwiperNav/fields";
import newcomer_report from "../components/TmsNewcomerReport/fields";
//营销
import biz_red_packet from "../components/TmsBizRedPacket/fields";
import form from "../components/TmsForm/fields";
import user_kpi from "../components/TmsUserKpi/fields";
// 玩法
import active_day from "../components/TmsActiveDay/fields";
import active_day2 from "../components/TmsActiveDay2/fields";
import active_day3 from "../components/TmsActiveDay3/fields";
import active_special from "../components/TmsActiveSpecial/fields";
import active_material from "../components/TmsActiveMaterial/fields";

// 废弃中
import biz_active_item from "../components/TmsActiveItem/fields";
import biz_search_box from "../components/TmsBizSearchBox/fields";
import biz_item_order from "../components/TmsBizItemOrder/fields";
import biz_service_order from "../components/TmsBizServiceOrder/fields";
import biz_article from "../components/TmsBizArticle/fields";
import biz_item from "../components/TmsBizItem/fields";
import biz_item_sale from "../components/TmsBizItemSale/fields";
import biz_service from "../components/TmsBizService/fields";
import biz_service_sale from "../components/TmsBizServiceSale/fields";
import biz_shop from "../components/TmsBizShop/fields";
import biz_coupon from "../components/TmsBizRedPackets/fields";
import biz_consume_record from "../components/TmsBizConsumeRecord/fields";
import biz_member_info from "../components/TmsBizMemberInfo/fields";
import biz_account_balance from "../components/TmsBizAccountBalance/fields";
import biz_recharge_record from "../components/TmsBizRechargeRecord/fields";
import biz_mine_form_group from "../components/TmsBizMineFormGroup/fields";
import biz_form_group from "../components/TmsBizFormGroup/fields";
import biz_mine_bargain from "../components/TmsBizMineBargain/fields";
import biz_bargain from "../components/TmsBizBargain/fields";

export {
    page,
    title,
    text,
    button,
    image_list,
    video,
    audio,
    form,
    biz_item,
    biz_active_item,
    image_set,
    middle_nav,
    top_nav,
    bottom_nav,
    notice_board,
    shop_header,
    personal_info,
    customer_service,
    custom_menu,
    split_line,
    biz_search_box,
    biz_item_order,
    biz_service_order,
    biz_article,
    biz_item_sale,
    biz_service,
    biz_service_sale,
    biz_shop,
    contact_info,
    biz_coupon,
    biz_consume_record,
    biz_member_info,
    biz_account_balance,
    biz_recharge_record,
    biz_mine_form_group,
    biz_form_group,
    biz_mine_bargain,
    biz_bargain,
    anchor,
    back_top,
    rule,
    countdown,
    copy_text,
    jump_app,
    biz_red_packet,
    user_kpi,
    active_day,
    active_day2,
    active_day3,
    active_special,
    active_material,
    bottom_float,
    fix_icon,
    swiper_nav,
    newcomer_report
};